import React, { useState } from "react";
import styles from "./RechargeWallet.module.css";
import welletIcon from "../../../Assets/Images/WelletIcon.svg"
import InputFields from "../../InputField/TextField/InputField";
import { useRazorpay } from "react-razorpay";
import { useSelector, useDispatch } from "react-redux";
import { createOrderAction } from "../../../Redux/Actions/razorpayAction";
import { useNavigate } from "react-router-dom";
import Loader from "../../Layouts/Loader/Loader";


const RechargeWallet = () => {
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false)
  const welletBlance = useSelector((state) => {
    return state?.getWalletData
  })


  const navigate = useNavigate();
  const [amount, setAmount] = useState("");
  const dispatch = useDispatch();
  const [chargeDetails, setChargeDetails] = useState({
    rechargeAmount: 0,
    gatewayCharges: 0,
    gst: 0,
    totalToCredit: 0,
  });
  const { error, isLoading, Razorpay } = useRazorpay();
  const getUserToken = useSelector((state) => {
    return state?.getLoggedInStatus?.data?.loginData?.token;
  });
  const userDetails = useSelector((state) => {
    return state?.getLoggedInStatus?.data?.loginData;
  });

  const handleRechargeInputChange = (e) => {
    const { value } = e.target;
    setAmount(value);

    const numericAmount = parseFloat(value);

    if (!numericAmount || numericAmount <= 0) {
      setErrors({ rechargeamount: "Please enter a valid amount" });
      setChargeDetails({
        rechargeAmount: 0,
        gatewayCharges: 0,
        gst: 0,
        totalToCredit: 0,
      });
      return;
    }

    // Clear errors
    setErrors({});

    const gatewayCharges = (numericAmount * 0.022); // 2.2%
    const gst = (gatewayCharges * 0.18); // 18%
    const totalToCredit = numericAmount - (gatewayCharges + gst);

    setChargeDetails({
      rechargeAmount: numericAmount,
      gatewayCharges: gatewayCharges.toFixed(2),
      gst: gst.toFixed(2),
      totalToCredit: totalToCredit.toFixed(2),
    });
  };

  const handlePaymentGatewaySubmit = async () => {
    if (chargeDetails?.totalToCredit) {
      //call order API
      setLoading(true)
      let reqData = {
        body: {
          data: {
            amount: chargeDetails.rechargeAmount
          }
        },
        userToken: getUserToken
      };
      let orderDetails = await dispatch(createOrderAction(reqData));

      const options = {
        // key: "rzp_test_uqpW9aFrYAgiaS", //UAT TEST
        key: "rzp_live_eOfMrykHBxydcR",//PROD
        amount: chargeDetails.rechargeAmount * 100, //sbiFullQuoteData?.DuePremium * 100,
        currency: "INR",
        name: "BrillJust Solutions Pvt Ltd.",
        description: "Recharge wallet",
        image: "https://brilljust-files-image.s3.ap-south-1.amazonaws.com/brilljust-logo/brillJust.png",
        order_id: orderDetails?.payload?.data?.id,
        modal: {
          ondismiss: function () {
            document.body.style.overflow = 'auto';
            setLoading(false)
          },
        },
        handler: async (res) => {
          try {
            document.body.style.overflow = 'auto'
            // adding response in the database when successfull payment
            // Production Url
            await fetch(
              `https://52lku5p2bj.execute-api.ap-south-1.amazonaws.com/Prod/prod_brilljust_razorpay_paymentWebhook`,
              {
                method: "POST",
                body: JSON.stringify(res),
                headers: {
                  "Content-Type": "application/json",
                  "Authorization": getUserToken
                },
              }
            ).then(response => response.json())
              .then(async (response) => {

                if (response?.data?.status == "captured" || response?.data?.status == "paid") {
                  // payment success page
                  navigate("/payment-confirmation")
                } else {
                  //payment failure page
                  setLoading(false)
                  alert("Payment Failed")

                }
              });
          } catch (rejectedValueOrSerializedError) {
            alert(" Something went wrong !");
            setLoading(false)
          }
        },
        prefill: {
          name: userDetails.first_name + " " + userDetails.last_name || "",
          email: userDetails.email || "",
          contact: userDetails.mobile || "", //"9999999999",
        },
        notes: {
          address: "Brilljust Solutions Corporate Office",
        },
        theme: {
          color: "#2C5ECD",
        },
      }
      const rzpay = new Razorpay(options);
      document.body.style.overflow = 'hidden';
      rzpay.open();

    } else {
      setErrors({ rechargeamount: "Please enter amount fisrt" });
    }
  };

  return (
    <div className={styles.container}>

      {loading && <Loader />}
      <h2 className={styles.heading}>Recharge Wallet</h2>


      <div className={styles.walletBox}>
        <div className={styles.walletIcon}>
          <img src={welletIcon} alt="wellecticon" />
        </div>
        <div>
          <p className={styles.walletText}>Current Wallet Balance</p>
          <h3 className={styles.walletAmount}>₹ {welletBlance?.data?.data?.balance}</h3>
        </div>
      </div>

      <div className={styles.inputSection}>
        <label htmlFor="amount">Enter recharge amount (₹)</label>
        <InputFields
          type="number"
          placeholder="Enter amount"
          name="rechargeamount"
          value={amount}
          onChangeEvent={handleRechargeInputChange}
          errState={errors?.rechargeamount ? true : false}
          errMsg={errors?.rechargeamount}
          errClassName="input-err"
        />
      </div>

      <div className={styles.breakdownSection}>
        <p className={styles.breakdownTitle}>Charges Breakdown</p>
        <div className={styles.breakdownRow}>
          <span>Recharge Amount (₹) :</span>
          <span>₹ {chargeDetails.rechargeAmount}</span>
        </div>
        <div className={styles.breakdownRow}>
          <span>Payment gateway charges (2.2%) :</span>
          <span>₹ {chargeDetails.gatewayCharges}</span>
        </div>
        <div className={styles.breakdownRow}>
          <span>GST on recharge amount (18%) :</span>
          <span>₹ {chargeDetails.gst}</span>
        </div>
        <div className={styles.totalRow}>
          <span>Total amount to be credited</span>
          <span>₹ {chargeDetails.totalToCredit}</span>
        </div>
      </div>

      <div className={styles.noticeBox}>
        <div>
          <span className={styles.warningIcon}>⚠️</span>
          <span>
            You are sending the amount to Brilljust Solutions Pvt Ltd. via a secure and trusted
            payment gateway.
          </span>
        </div>
        <button
          className={styles.paymentBtn}
          onClick={handlePaymentGatewaySubmit}
        >
          Make Payment
        </button>
      </div>
    </div>
  );
};

export default RechargeWallet;
